import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import HomePage from "./pages/HomePage";
import FeaturesPage from "./pages/FeaturesPage";
import AssessmentsPage from "./pages/AssessmentsPage";
import AIMatchingPage from "./pages/AIMatchingPage";
import InterviewsPage from "./pages/InterviewsPage";
import PlatformPage from "./pages/PlatformPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/assessments" element={<AssessmentsPage />} />
          <Route path="/ai-matching" element={<AIMatchingPage />} />
          <Route path="/interviews" element={<InterviewsPage />} />
          <Route path="/platform" element={<PlatformPage />} />
          {/* <Route path="/pricing" element={<PricingPage />} /> */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
